<div id="printCalendarEventInfo">
  <div class="modal-header">
    <h5 class="modal-title text-capitalize" id="exampleModalLabel">
      <i class="fas fa-info-circle"></i> &nbsp; {{'BookingServiceDetails' | translate}}
    </h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">

      <div class="col-md-12" *ngIf="CalendarEvent">
        <div class="table-card1">
          <div class="table-responsive1 text-nowrap1">
            <table class="table table-stripedd table-sm table-bordered">
              <thead class="table-head">
                <tr>
                  <th colspan="2"><i class="fas fa-info-circle px-2"></i> {{'BookingServiceDetails' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{{ 'BookingNumber' | translate }}</th>
                  <td>{{CalendarEvent?.Id }}</td>
                </tr>
                <tr>
                  <td>{{ 'BookingType' | translate }}</td>
                  <td>
                    <span *ngIf="CalendarEvent?.bookingPlace == 0">{{'InCenter' | translate}}</span>
                    <span *ngIf="CalendarEvent?.bookingPlace == 1">{{'InHome' | translate}}</span>
                  </td>
                </tr>

                <tr>
                  <th>{{ 'ClientName' | translate }}</th>
                  <td>{{CalendarEvent?.name }} </td>
                </tr>
                <tr>
                  <th>{{ 'ClientMobile' | translate }}</th>
                  <td>{{CalendarEvent?.mobile }}</td>
                </tr>
                <tr
                  *ngIf="CalendarEvent?.bookingPlace == 1 && (CalendarEvent?.clientAddress || CalendarEvent?.clientAddressText)">
                  <td>{{ 'ClientAddress' | translate }}</td>
                  <td>{{ CalendarEvent?.clientAddress ? (CalendarEvent?.clientAddress?.Label +" : "+
                    CalendarEvent?.clientAddress?.ApartmentNo +','+
                    CalendarEvent?.clientAddress?.BuildingNo + ', '+
                    CalendarEvent?.clientAddress?.Street + ', '+
                    CalendarEvent?.clientAddress?.Area) : CalendarEvent?.clientAddressText}}
                  </td>
                </tr>
                <tr *ngIf="CalendarEvent?.bookingPlace == 1 && (CalendarEvent?.clientAddress)">
                  <td>{{ 'ClientLocation' | translate }}</td>
                  <td>
                    <a class="text-blue" target="_blank"
                      href="https://www.google.com/maps?q={{ CalendarEvent?.clientAddress.Latitude}},{{ CalendarEvent?.clientAddress.Longitude}}">{{'ClickToNavigate'
                      | translate}}</a>
                  </td>
                </tr>
                <tr>
                  <th>{{ 'BookingDate' | translate }}</th>
                  <td> {{ CalendarEvent?.start | date:'short'}}</td>
                </tr>

                <tr>
                  <th *ngIf="sharedService.AllowAccessToClientsMobileNumbers == true">{{ 'Mobile' | translate }}</th>
                  <td *ngIf="sharedService.AllowAccessToClientsMobileNumbers == true">{{CalendarEvent?.mobile }}</td>
                </tr>
                <tr>
                  <th>{{ 'Service' | translate }}</th>
                  <td>{{CalendarEvent?.service }}</td>
                </tr>

                <tr>

                  <th>{{ 'ItemDateAndTime' | translate }}</th>
                  <td>
                    <span class=" ">
                      {{CalendarEvent?.ItemDateAndTime | date:'yyyy/MM/dd hh:mm a'}}
                    </span>
                  </td>
                </tr>
                <tr>

                  <th>{{ 'TheItemPrice' | translate }}</th>
                  <td>
                    <span class="font-weight-bold">
                      {{CalendarEvent?.ItemPrice.toFixed(sharedService.GetFractionRoundCount)}}
                      <small>{{DefaultAccountCurrencyName}}</small>
                    </span>
                  </td>
                </tr>
                <tr>

                  <th>{{ 'BookingTotal' | translate }}</th>
                  <td>
                    <span class=" font-weight-bold">
                      {{CalendarEvent?.TotalAmount.toFixed(sharedService.GetFractionRoundCount)}}
                      <small>{{DefaultAccountCurrencyName}}</small>
                    </span>
                  </td>
                </tr>

                <tr>
                  <th>{{ 'Employee' | translate }}</th>
                  <td>
                    {{CalendarEvent?.emp1 ? "- " + CalendarEvent?.emp1 : ""}} <br>
                    {{CalendarEvent?.emp2 ? "- " + CalendarEvent?.emp2 : ""}}
                  </td>
                </tr>

                <tr *ngIf="CalendarEvent?.GymGroupStartDate">

                  <th>{{ 'GymGroupStartDate' | translate }}</th>
                  <td>
                    <span class=" ">
                      {{CalendarEvent?.GymGroupStartDate | date:'yyyy/MM/dd'}}
                    </span>
                  </td>
                </tr>

                <tr *ngIf="CalendarEvent?.GymGroupEndDate">

                  <th>{{ 'GymGroupEndDate' | translate }}</th>
                  <td>
                    <span class=" ">
                      {{CalendarEvent?.GymGroupEndDate | date:'yyyy/MM/dd'}}
                    </span>
                  </td>
                </tr>

                <tr *ngIf="CalendarEvent?.GroupSessions && CalendarEvent?.GroupSessions.length > 0">

                  <th>{{ 'GroupSessions' | translate }}</th>
                  <td>
                    <span *ngFor="let item of CalendarEvent?.GroupSessions ; let i = index">
                      {{i+1}} - {{ 'From' | translate }} {{(item.TimeFrom | date:'hh:mm a') + " " + ('To' | translate) +
                      " " + (item.TimeTo | date:'hh:mm a')}}
                      <br>
                    </span>
                  </td>
                </tr>

                <tr
                  *ngIf="sharedService.CurrentBranch.AllowTheUseOfTheBookingServicesNumberingSystem && CalendarEvent?.itemNumber">
                  <th>{{ 'ItemNumber' | translate }}</th>
                  <td>
                    <div class="row">
                      <div class="col-lg-3">
                        <input type="number" (keypress)="sharedService.allowNumbersOnly($event)" min="1" step="0"
                          name="ItemNumber" class="form-control" style="height:100%;"
                          [(ngModel)]="CalendarEvent.newItemNumber" [value]="CalendarEvent.itemNumber">
                      </div>
                      <div class="col-lg-7">
                        <button type="button" class=" btn my-0 px-3 editOnlyClass"
                          [disabled]="CalendarEvent.itemNumber == CalendarEvent.newItemNumber || LoadingEditItemNumber"
                          (click)="editItemNumber(CalendarEvent,updateItemNumberType.UpdateOnly)">
                          <i *ngIf="LoadingEditItemNumber" class="fas fa-spinner fa-spin"></i> <i
                            *ngIf="!LoadingEditItemNumber" class="fas fa-edit"></i> &nbsp; {{ 'EditOnly' | translate }}
                        </button>
                        <button type="button" class="btn my-0 px-3 editAndReplaceClass"
                          [disabled]="CalendarEvent.itemNumber == CalendarEvent.newItemNumber || LoadingEditItemNumber"
                          (click)="editItemNumber(CalendarEvent,updateItemNumberType.UpdateAndReplace)">
                          <i *ngIf="LoadingEditItemNumber" class="fas fa-spinner fa-spin"></i><i
                            *ngIf="!LoadingEditItemNumber" class="fas fa-exchange"></i> &nbsp;{{ 'EditAndReplace' |
                          translate }}
                        </button>
                      </div>
                    </div>

                  </td>
                </tr>

                <tr>
                  <th>{{ 'Message' | translate }}</th>
                  <td>
                    <form>
                      <div class="input-group mb-3 msg">
                        <input type="text" class="form-control" placeholder="{{'message' | translate}}"
                          aria-label="Example text with button addon" aria-describedby="button-addon1"
                          [(ngModel)]="message.sms" name="sms">
                        <button class="btn" type="button" id="button-addon1"
                          (click)="SendManualSms(CalendarEvent?.ClientId)">{{'SendMessage' | translate}}</button>
                      </div>
                    </form>
                  </td>
                </tr>

                <tr>
                  <td>{{ 'BookingAddedDate' | translate }}</td>
                  <td>
                    {{ CalendarEvent?.AddedDate | date:'dd/MM/yyyy - hh:mm a'}}
                  </td>
                </tr>

                <tr *ngIf="CalendarEvent?.AddedByDevice">
                  <td>{{ 'AddedBy' | translate }}</td>
                  <td> {{addedByDevice[CalendarEvent?.AddedByDevice] | translate}}

                    <span *ngIf="CalendarEvent?.AddedByDevice == addedByDevice.GlameraBusinessWebInBranch">
                      &nbsp;&nbsp; ( {{ CalendarEvent?.UserName}} )
                    </span>

                  </td>
                </tr>

                <tr>
                  <th>{{ 'PaymentStatus' | translate }}</th>
                  <td>
                    <span *ngIf="CalendarEvent?.IsPaid == 1" class="text-success">{{ 'DonePayment' | translate
                      }}</span>
                    <span *ngIf="CalendarEvent?.IsPaid == 0" class="text-danger">{{ 'NotDonePayment' | translate
                      }}</span>
                  </td>
                </tr>
                <tr>
                  <th>{{ 'BookingStatus' | translate }} </th>
                  <td>
                    <!-- {{CalendarEvent?.status | translate }} -->
                    <div class="row">
                      <div class="col-lg-3">
                        <div class="input-group" *ngIf="sharedService.CheckAuthorization(4017)" style="width: 150px;">
                          <!-- *ngIf="sharedService.CheckAuthorization(4024)" -->
                          <select class="form-control" style="width: 140px;" name="BookingStatus"
                            [ngModelOptions]="{standalone: true}" [(ngModel)]="CalendarEvent.BookingStatus"
                            (change)="UpdateBookingStatus($event, CalendarEvent)">
                            <option *ngFor="let status of bookingStatus"
                              [selected]="status.name == CalendarEvent?.status" [value]="status.id">{{status.name |
                              translate}}</option>
                          </select>

                        </div>
                      </div>
                      <div class="col-lg-3">
                        <button type="button" title="{{('TryAgain' |translate)}}"
                          [disabled]="UpdateBookingStatusLoading" *ngIf="CalendarEvent?.RequestPermissionNotificationId
                        && CalendarEvent?.RequestPermissionNotificationId > 0
                        && CalendarEvent?.BookingStatus == bookingStatusEnum.Canceled"
                          class="btn tryAginButton text-center" (click)="UpdateBookingStatus(null, CalendarEvent)">
                          <i *ngIf="!UpdateBookingStatusLoading" style="font-size: 15px;color: white;"
                            class="fas fa-refresh text-center"></i>
                          <i *ngIf="UpdateBookingStatusLoading" style="font-size: 15px;color: white;"
                            class="fas fa-sync fa-spin text-center"></i>
                        </button>
                      </div>

                    </div>


                  </td>
                </tr>
                <!-- <tr
                  *ngIf="AccountSetup?.AllowUseServiceImages == true && CalendarEvent?.bookingServiceImages.length != 0">

                  <th>{{ 'ServiceImages' | translate }}</th>
                  <td>
                    <div *ngFor="let bsimg of CalendarEvent?.bookingServiceImages">
                      <div class="d-flex">
                        <div>
                          <img src="{{bsimg.ServiceImage?.ImagePath}}" alt="" width="300"><br>
                        </div>
                        <div>
                          <p *ngFor="let note of bsimg.BookingServiceImageNotes; let n = index">
                            {{n+1}} - {{note.NoteText}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr> -->
                <tr *ngIf="CalendarEvent?.bookingNotes">
                  <th> {{ 'Notes' | translate }}</th>
                  <td> {{CalendarEvent?.bookingNotes}} </td>
                </tr>
                <tr>
                  <th>{{'Actions' | translate}}</th>
                  <td>
                    <a *ngIf=" sharedService.CheckAuthorization(4018)" type="button" class="btn btn-modal-action"
                      (click)="activeModal.dismiss('Cross click')"
                      routerLink="/appointment/booking/{{CalendarEvent.Id}}"
                      title="{{'Edit  rrrr' | translate}}">
                      {{'Edit' | translate}}
                    </a>

                    <a type="button" *ngIf="sharedService.CheckAuthorization(4025)" class="btn btn-modal-action"
                      routerLink="/bookings/booking-add/{{CalendarEvent.Id}}/reorder" data-toggle="tooltip"
                      (click)="activeModal.dismiss('Cross click');" data-placement="top"
                      title="{{'Reorder' | translate}}" >
                      {{'Reorder' | translate}}
                    </a>

                    <button *ngIf="CalendarEvent.IsPaid != paidStatus.Paid" type="button" class="btn btn-modal-action"
                      title="{{'ThePayment' | translate}}" data-toggle="modal" data-target="#modalClientDownPayment"
                      (click)="openModalClientDownPayment(); activeModal.dismiss('Cross click')">
                      {{'ClientDownPayment'|translate}}
                    </button>

                    <!-- *ngIf="(booking.IsPaid != paidStatus.Paid) &&
                booking.EnablePayment && booking.BookingStatusDesc != 'Unconfirmed'
                && booking.BookingStatusDesc != 'Canceled'
                && sharedService.CheckAuthorization(4027)
                  " -->

                    <!-- EnablePayment: {{CalendarEvent?.EnablePayment}} <br>
                    payment : {{CalendarEvent?.IsPaid}} <br>
                    status: {{CalendarEvent?.status}} <br>
                    paidStatus: {{paidStatus.Paid}} <br> -->
                    <!-- (click)="open(content)" -->
                    <button *ngIf="(CalendarEvent?.IsPaid != paidStatus.Paid)
                    && CalendarEvent?.EnablePayment
                    && CalendarEvent?.status != 'Unconfirmed'
                    && CalendarEvent?.status != 'Canceled'
                    && sharedService.CheckAuthorization(4027)" type="button" class="btn btn-modal-action"
                      title="{{'ThePayment' | translate}}" data-toggle="modal" data-target="#modalPayment"
                      (click)="activeModal.dismiss('Cross click'); openModalPayment()">
                      {{'ThePayment' | translate}}
                    </button>

                    <!-- <button type="button" class="btn btn-modal-action" data-toggle="modal"
                      data-target="#modalClientDetails" (click)="SetClintId($event, modalData); close()">
                      جميع بيانات العميل
                    </button> -->
                  </td>

                </tr>
                <tr>
                  <!-- <td>{{CalendarEvent?.start | date:'d-M-yyyy'}}</td> -->
                  <!-- <td>{{CalendarEvent?.ClientId }}</td> -->
                  <!-- <td>{{CalendarEvent?.IsPaid | translate }}</td> -->
                </tr>

              </tbody>
            </table>
          </div>

        </div>
      </div>

      <div class="col-lg-12" *ngIf="!CalendarEvent">
        <div class="col-md-12 text-center py-4 my-4">
          <i class="fas fa-circle-notch fa-spin fa-3x"></i>
          <h1>{{'Loading' | translate}} </h1>
        </div>
      </div>

    </div>


  </div>
  <div class="modal-footer">

    <button type="button" class="btn btn-danger" (click)="activeModal.close('Close click')">
      {{'Close' | translate}}</button>

    <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="printPage()">{{'Print' |
      translate}}</button>
  </div>
</div>
